import { useTranslation } from 'react-i18next';

import { Box, ErrorState, Button } from '@hawkins/components';
import { Colors, Dimensions } from '@hawkins/variables';

import { TranslationNamespace } from '../../types';
import { Page } from '../Page';

export default function MaintenancePage() {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <Page>
      <Box display="flex" justifyContent="center" paddingX={Dimensions.Space16}>
        <ErrorState
          actions={
            <Button
              variant="primary"
              href="mailto:legalprocess@netflix.com"
              style={{ color: Colors.White, textDecoration: 'none' }}
            >
              Contact Support
            </Button>
          }
          title={t('maintenance_title')}
          subtitle={t('maintenance_message')}
        />
      </Box>
    </Page>
  );
}